<template>
  <span
    class="inline-flex items-center justify-center rounded-md border bg-gray-700 px-2 text-xs font-light group/badge"
    :class="[
      borderRef,
      textRef,
      text,
      background,
      { 'font-semibold': bold },
      { uppercase: !noUppercase },
      { 'py-1': !noPaddingY },
    ]"
    ><slot name="prefix"></slot><slot></slot><slot name="suffix"></slot
  ></span>
</template>

<script lang="ts" setup>
interface Props {
  color?: string;
  bold?: boolean;
  background?: string;
  text?: string;
  noPaddingY?: boolean;
  noUppercase?: boolean;
}

const props = defineProps<Props>();

const borderRef = computed(() => {
  switch (props.color) {
    case "green":
      return `border-green-300`;
    case "red":
      return `border-red-300`;
    case "yellow":
      return `border-yellow-300`;
    case "blue":
      return `border-blue-300`;
    case "indigo":
      return `border-primary-300`;
    case "gray":
      return `border-gray-300`;
    case "darkgray":
      return `border-gray-500`;
    default:
      return "border-blue-300";
  }
});

const textRef = computed(() => {
  switch (props.color) {
    case "green":
      return `text-green-300`;
    case "red":
      return `text-red-300`;
    case "yellow":
      return `text-yellow-300`;
    case "blue":
      return `text-blue-300`;
    case "indigo":
      return `text-primary-300`;
    case "gray":
      return `text-gray-300`;
    default:
      return "text-blue-300";
  }
});
</script>
